import { render } from "./fieldText.vue?vue&type=template&id=b6918204"
import script from "./fieldText.vue?vue&type=script&lang=js"
export * from "./fieldText.vue?vue&type=script&lang=js"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__